import { FETCH_ORDER_HISTORY_SUCCESS, FETCH_ORDER_HISTORY_REQUEST, FETCH_ORDER_HISTORY_ERROR } from '../constants/ActionTypes'

export default function isFetchingOrderHistory(state = { recent: false, past: false }, action) {
    switch (action.type) {
        case FETCH_ORDER_HISTORY_REQUEST:
            return {
                ...state,
                [action.payload.category]: true
            }

        case FETCH_ORDER_HISTORY_SUCCESS:
        case FETCH_ORDER_HISTORY_ERROR:
            return {
                ...state,
                [action.payload.category]: false
            }

        default:
            return state
    }
}
